export class RemoteCallError extends Error {
  constructor(descriptor: string) {
    super(descriptor);
    this.name = 'RemoteCallError';
  }
}

export class CrashlyticsLogicError extends Error {
  constructor(descriptor: string) {
    super(descriptor);
    this.stack = `${descriptor} ${this.stack}`;
  }
}

export class CrashlyticsFatalError extends Error {
  constructor(exception: Error, descriptor: string) {
    super(exception.message);
    this.stack = `${descriptor} ${exception.stack}`;
  }
}

export const responseFailedError = new Error(
  'Response failed with success false',
);
